export const homepage = {
  page: "homepage",
  title: "AI Market Research Platform | Insights in Hours",
  description:
    "AI-powered market research platform to generate insights in hours. No surveys, no bias, and no respondent fatigue.",
  keywords: "",
  image: "https://generativeinsight.ai/json-media/img/GI.png",
  url: "https://generativeinsight.ai/",
  publisher: "Generative Insight",
  author: "Generative Insight",
  site_name: "Generative Insight",
  locale: "en_US",
  type: "",
  canonical: "",
};
export const solution = {
  page: "Solution",
  title: "AI Research Solutions for Faster Market Insights",
  description:
    "AI research solutions to speed up decision-making. Automate research workflows and get continuous customer insights.",
  keywords: "",
  image: "https://generativeinsight.ai/json-media/img/GI.png",
  url: "https://generativeinsight.ai/solution",
  publisher: "Generative Insight",
  author: "Generative Insight",
  site_name: "Generative Insight",
  locale: "en_US",
  type: "",
  canonical: "",
};
export const howItWorks = {
  page: "How It Works",
  title: "How AI Market Research Works | Faster Consumer Insights",
  description:
    "Learn how the AI market research platform generates customer insights using behavioral data, segmentation, and automated research workflows.",
  keywords: "",
  image: "https://generativeinsight.ai/json-media/img/GI.png",
  url: "https://generativeinsight.ai/how-it-works",
  publisher: "Generative Insight",
  author: "Generative Insight",
  site_name: "Generative Insight",
  locale: "en_US",
  type: "",
  canonical: "",
};
export const pricing = {
  page: "Pricing",
  title: "AI Market Research Pricing | Flexible Research Plans",
  description:
    "Explore pricing plans for AI-powered market research and customer insights. Choose a plan that fits your research goals and team needs.",
  keywords: "",
  image: "https://generativeinsight.ai/json-media/img/GI.png",
  url: "https://generativeinsight.ai/pricing",
  publisher: "Generative Insight",
  author: "Generative Insight",
  site_name: "Generative Insight",
  locale: "en_US",
  type: "",
  canonical: "",
};

export const aboutUs = {
  page: "About Us",
  title: "About Us | AI-Powered Market Research Company",
  description:
    "Learn about our mission to simplify market research with AI-driven consumer insights, faster analysis, and scalable research solutions.",
  keywords: "",
  image: "https://generativeinsight.ai/json-media/img/GI.png",
  url: "https://generativeinsight.ai/about",
  publisher: "Generative Insight",
  author: "Generative Insight",
  site_name: "Generative Insight",
  locale: "en_US",
  type: "",
  canonical: "",
};